import i18n from '@/lang/i18n'

export default [{
  path: '/admin/login',
  name: 'Login',
  component: () => import('@/views/login/login'),
  meta: {
    title: i18n.t('router.login.site_login'),
    keepAlive: false,
    auth: false,
    headType: -1
  },
  alias: ['/', '/admin']
}]



// WEBPACK FOOTER //
// ./src/router/login.js